import { render } from "./PersonDocumentTable.vue?vue&type=template&id=387ac667"
import script from "./PersonDocumentTable.vue?vue&type=script&lang=js"
export * from "./PersonDocumentTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__